export var DAY_SIZE = 36;
export var DAY_MARGIN = 2;
export var DIALOG_WIDTH = 320;
export var VIEW_HEIGHT = 358;